import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const { cmsListingBegin, cmsListingSuccess, cmsListingErr, updateCmsBegin, updateCmsSuccess, updateCmsErr, getCmsBegin, getCmsSuccess, getCmsErr, cmsDeleteBegin, cmsDeleteErr, cmsDeleteSuccess} = actions;

const CmsListAPIName = '/admin/cms-list';
const CmsUpdateAPIName = '/admin/updateCms';
const GetCmsAPIName = '/admin/cms-detail/';
const DeleteCmsAPI = '/admin/delete-cms/';
const GetCmsContentAPIName = '/admin/get-listing-cms';

const cmsListing = (values) => {
  return async (dispatch) => {
    dispatch(cmsListingBegin());
    try {
      const response = await DataService.post(CmsListAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(cmsListingErr(response?.data?.message));
      } else {
        dispatch(cmsListingSuccess(response?.data));
        // callback();
        return response?.data?.result;
      }
    } catch (err) {
      dispatch(cmsListingErr(err));
    }
  };
};

const updateCms = (values) => {
  return async (dispatch) => {
    dispatch(updateCmsBegin());
    try {
      const response = await DataService.post(CmsUpdateAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(updateCmsErr(response?.data?.message));
      } else {
        dispatch(updateCmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(updateCmsErr(err));
    }
  };
};

const getCms = (values) => {
  return async (dispatch) => {
    dispatch(getCmsBegin());
    try {
      const response = await DataService.get(GetCmsAPIName + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getCmsErr(response?.data?.message));
      } else {
        dispatch(getCmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getCmsErr(err));
    }
  };
};
const cmsDelete = (values) => {
  return async (dispatch) => {
    dispatch(cmsDeleteBegin());
    try {
      const response = await DataService.delete(DeleteCmsAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(cmsDeleteErr(response?.data?.message));
      } else {
        dispatch(cmsDeleteSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(cmsDeleteErr(err));
    }
  };
};

const fetchCmsContent = (values) => {
  return async (dispatch) => {
    dispatch(getCmsBegin());
    try {
      const response = await DataService.post(GetCmsContentAPIName,values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getCmsErr(response?.data?.message));
      } else {
        dispatch(getCmsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getCmsErr(err));
    }
  };
};

export { cmsListing, updateCms, getCms, cmsDelete,fetchCmsContent };
